// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__B2hgV","list":"FAQ_list__B+j7X","groupTitle":"FAQ_groupTitle__EcSNg"};